import { getManifest } from '../ManifestService/ManifestService';

const TRANSLATION_MAP: { [key: string]: string } = {
  'nl-BE': 'nl',
  'en-GB': 'en',
  'fr-BE': 'fr',
  'fr-FR': 'fr-FR',
  'de-DE': 'de',
  'de-CH': 'de-CH',
  'es-ES': 'es',
  'it-IT': 'it',
  'nl-NL': 'nl-NL',
  'da-DK': 'da',
  'pt-PT': 'pt',
  'pl-PL': 'pl',
  'tr-TR': 'tr',
  'nb-NO': 'no',
  'fi-FI': 'fi',
  'sv-SE': 'sv',
  'tlh-KL': 'tlh-KL',
};

let translations: { legacy: Record<string, string> } | {} = {};

export const loadPath = async (language: string) => {
  if (environment.BUST_TRANSLATIONS_CACHE_ON_RELOAD) {
    return `/i18n/${language}/legacyJavascriptTranslations.json?v=${Date.now()}`;
  }

  const manifest = await getManifest();

  if (manifest.core.translations['legacyJavascriptTranslations']) {
    const fileName = manifest.core.translations['legacyJavascriptTranslations'][language];

    return `${environment.STATIC_DOMAIN}/web/core/translations/legacyJavascriptTranslations/${fileName}`;
  }

  return '';
};

export async function load(languageKey?: string) {
  if (!languageKey) {
    languageKey = 'tlh-KL';
  }

  const languageKeyFromMap = TRANSLATION_MAP[languageKey];

  const filePath = await loadPath(languageKeyFromMap);

  fetch(filePath, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.text())
    .then((translationsFetched) => (translations = JSON.parse(translationsFetched)));
}

export function translate(translationKey: string) {
  if ('legacy' in translations) {
    if (translationKey in translations['legacy']) {
      return translations.legacy[translationKey];
    }
  }

  return translationKey;
}
